<template>
  <div class="userinformations" v-if="selectedUser !== null">
    <h3>{{ selectedUser.displayname }}'s Gruppen</h3>
    <Divider></Divider>
    <br>
    <div class="userinformations-grid">
      <FloatLabel class="w-full md:w-80" variant="in">
        <MultiSelect class="cua-modal-btn" id="in_label" v-model="selectedGroups" :options="groups"
          :maxSelectedLabels="3" optionLabel="name" />
        <label for="in_label">Gruppen</label>
      </FloatLabel>
    </div>
    <br>
    <Button class="cua-modal-btn" :disabled="loading" on="fa-solid fa-disk" @click="save" severity="primary" text
      outlined label="Speichern"></Button>
  </div>
</template>
<script>
import router from '../router/index.js'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import FloatLabel from 'primevue/floatlabel'
import InputSwitch from 'primevue/inputswitch'
import CreateUserDialog from './CreateUserDialog.vue'
import ConfirmPopup from 'primevue/confirmpopup'
import { RouterLink, useRouter } from 'vue-router'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import axios from 'axios'
import { config } from '../assets/config.js'
import UserInformationComponent from './UserInformationComponent.vue'
import { useAuthStore } from '@/stores/auth.js'
import MultiSelect from 'primevue/multiselect'
import Divider from 'primevue/divider'

export default {
  components: {
    Dialog,
    Button,
    FloatLabel,
    InputText,
    InputSwitch,
    ConfirmPopup,
    UserInformationComponent,
    MultiSelect,
    Divider
  },

  props: {
    selectedUser: Object
  },

  data() {
    return {
      authStore: useAuthStore(),
      loadingActivation: false,
      selectedGroups: [],
      groups: []
    }
  },

  methods: {
    async fetchGroups() {
      try {
        let GroupsResponse = await axios.post(
          config.api_url + '/api/getGroups',
          {},
          {
            headers: {
              Authorization: await getAuth().currentUser.getIdToken()
            }
          }
        );

        if (GroupsResponse.status === 200) {
          this.groups = GroupsResponse.data || [];
          this.updateSelectedGroups();
        }
      } catch (error) {
        console.error('Error fetching groups:', error);
      }
    },
    async save() {

      this.loading = true

      if (this.selectedGroups == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'Speicherung fehlgeschlagen',
          group: "tc",
          detail:
            'Du musst mindestens eine Gruppe wählen.',
          life: 5000
        })

        this.loading = false;

        return;
      }

      let response = await axios.post(config.api_url + '/api/management/users/save', {
        userid: this.selectedUser.uid,
        groupid: this.selectedGroups,
      },
        {
          headers: {
            Authorization: await getAuth().currentUser.getIdToken()
          },

        })

      if (response.status == 200) {
        window.location.reload();
        this.$toast.add({
          severity: 'success',
          summary: 'Erfolg',
          group: "tc",
          detail: "Erfolgreich Gruppe Gesetzt.",
          life: 5000
        })
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Fehlermeldung',
          group: "tc",
          detail:
            response.data,
          life: 5000
        })
      }
      this.loading = false;
    },

    updateSelectedGroups() {
      if (this.selectedUser && Array.isArray(this.selectedUser.groups)) {
        this.selectedGroups = this.groups.filter(group =>
          group && group.name && this.selectedUser.groups.includes(group.name)
        );
      } else {
        this.selectedGroups = [];
      }
    }


  },

  watch: {
    selectedUser: {
      handler(newUser) {
        if (newUser) {
          this.fetchGroups();
        } else {
          this.selectedGroups = [];
        }
      },
      immediate: true
    },

    groups: {
      handler() {
        this.updateSelectedGroups();
      }
    }
  },

  async mounted() {
    await this.fetchGroups();
  }

}

</script>
<style lang="scss" scoped>
.userinformations {
  &-grid {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    gap: 0.7rem;
    padding: 0 0 1rem 0;
  }
}
</style>
